module.exports = __webpack_public_path__ + "img/yinbingC.3f893bdc.png";